import React, { useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

const translations = {
  en: {
    home: 'Home',
    about: 'About',
    processes: 'Processes',
    sectors: 'Sectors',
    gallery: 'Gallery',
    contact: 'Contact',
  },
  de: {
    home: 'Startseite',
    about: 'Über Seite',
    processes: 'Prozesse',
    sectors: 'Sektoren',
    gallery: 'Galerie',
    contact: 'Kontakte',
  },
  bg: {
    home: 'Начало',
    about: 'За нас',
    processes: 'Процеси',
    sectors: 'Сектори',
    gallery: 'Галерия',
    contact: 'Контакти',
  },
};

const Nav = ({ lang }) => {
  const { allProcessesJson: links } = useStaticQuery(graphql`
    query SECONDARY_NAV_ITEMS {
      allProcessesJson {
        edges {
          node {
            title
            parent {
              ... on File {
                name
              }
            }
            languages {
              en {
                intro {
                  title
                }
              }
              de {
                intro {
                  title
                }
              }
              bg {
                intro {
                  title
                }
              }
            }
          }
        }
      }
    }
  `);

  const getActiveClass = path => {
    if (
      typeof window !== `undefined` &&
      window.location.pathname === `/${lang}${path}`
    ) {
      return 'active';
    }

    return '';
  };

  //Check for mobile and expand submenu if so
  useEffect(() => {
    const expandSubmenu = e => {
      if (window.innerWidth < 768) {
        const { parentElement } = e.target;

        if (!parentElement.classList.contains('active')) {
          e.preventDefault();
          parentElement.classList.add('active');
        }
      }
    };

    document
      .querySelectorAll('.nav .nav__item-has-submenu > .nav__link')
      .forEach(item => {
        item.addEventListener('click', expandSubmenu);
      });

    return () => {
      document
        .querySelectorAll('.nav .nav__item-has-submenu > .nav__link')
        .forEach(item => {
          item.removeEventListener('click', expandSubmenu);
        });
    };
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-end justify-content-md-start">
      <nav className="nav mr-md-12">
        <ul>
          <li className="nav__item">
            <AniLink
              cover
              direction="up"
              bg="#092431"
              className={`nav__link text-right text-md-left d-block ${getActiveClass(
                ''
              )}`}
              to={`/${lang}`}
            >
              {translations[lang].home}
            </AniLink>
          </li>

          <li className="nav__item">
            <AniLink
              cover
              direction="up"
              bg="#092431"
              className={`nav__link text-right text-md-left d-block ${getActiveClass(
                '/about'
              )}`}
              to={`/${lang}/about`}
            >
              {translations[lang].about}
            </AniLink>
          </li>

          <li className="nav__item nav__item-has-submenu position-relative">
            <AniLink
              cover
              direction="up"
              bg="#092431"
              className={`nav__link text-right text-md-left d-block ${getActiveClass(
                '/processes'
              )}`}
              to={`/${lang}/processes`}
            >
              {translations[lang].processes}
            </AniLink>

            <div className="nav__submenu">
              <ul className="row">
                {links.edges
                  .sort((a, b) => {
                    if (a.node.parent.name < b.node.parent.name) {
                      return -1;
                    } else {
                      return 1;
                    }
                  })
                  .map(({ node }) => (
                    <li
                      key={node.title}
                      className="nav__submenu-item col-md-6 col-lg-4 col-xl-3"
                    >
                      <AniLink
                        cover
                        direction="up"
                        bg="#092431"
                        className={`nav__link h-100 d-flex align-items-center justify-content-end justify-content-md-start pr-md-5 pr-lg-7 pr-xl-0 ${getActiveClass(
                          `/processes/${node.title
                            .toLowerCase()
                            .replace(/ /g, '-')}`
                        )}`}
                        to={`/${lang}/processes/${node.title
                          .toLowerCase()
                          .replace(/ /g, '-')}`}
                      >
                        {node.languages[lang].intro.title}
                      </AniLink>
                    </li>
                  ))}
              </ul>
            </div>
          </li>

          <li className="nav__item">
            <AniLink
              cover
              direction="up"
              bg="#092431"
              className={`nav__link text-right text-md-left d-block ${getActiveClass(
                '/sectors'
              )}`}
              to={`/${lang}/sectors`}
            >
              {translations[lang].sectors}
            </AniLink>
          </li>

          <li className="nav__item">
            <AniLink
              cover
              direction="up"
              bg="#092431"
              className={`nav__link text-right text-md-left d-block ${getActiveClass(
                '/gallery'
              )}`}
              to={`/${lang}/gallery`}
            >
              {translations[lang].gallery}
            </AniLink>
          </li>

          <li className="nav__item">
            <AniLink
              cover
              direction="up"
              bg="#092431"
              className={`nav__link text-right text-md-left d-block ${getActiveClass(
                '/contact'
              )}`}
              to={`/${lang}/contact`}
            >
              {translations[lang].contact}
            </AniLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Nav;
